import { Suspense } from 'react';
import { useSelector } from 'react-redux';
import SpringConfigs from 'utils/constants/swarm/spring-configs';
import { lazy } from 'utils/generic/lazy';
import { getIsLoggedIn } from 'store/selectors/user-data';

const { DeRealityCheck } = lazy(
  () =>
    import(
      /* webpackChunkName: "de-reality-check" */ 'newcomponents/Shared/account/DeRealityCheck'
    )
);

export const CheckDeRealityCheck = () => {
  const isLoggedIn = useSelector(getIsLoggedIn);

  if (!(SpringConfigs.SHOW_REALITY_CHECK && isLoggedIn)) {
    return null;
  }

  return (
    <Suspense fallback={null}>
      <DeRealityCheck />
    </Suspense>
  );
};
